import { Delaunay } from 'd3-delaunay';

/**
 * Thin wrapper around d3-delaunay so the sketch never has to think about
 * flat coordinate arrays or clipping bounds.
 *
 * @param {{x: number, y: number}[]} sites
 * @param {[number, number, number, number]} bounds [xmin, ymin, xmax, ymax]
 */
export function buildVoronoi(sites, bounds) {
  const delaunay = Delaunay.from(
    sites,
    (s) => s.x,
    (s) => s.y,
  );
  return delaunay.voronoi(bounds);
}

/** Shoelace area of a closed polygon: [[x, y], ...]. */
export function polygonArea(polygon) {
  if (!polygon || polygon.length < 3) return 0;
  let sum = 0;
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    sum += polygon[j][0] * polygon[i][1] - polygon[i][0] * polygon[j][1];
  }
  return Math.abs(sum) / 2;
}

/**
 * Area captured by each player, keyed by player index.
 * @returns {number[]} area per player, in square pixels
 */
export function areaByPlayer(sites, bounds, playerCount) {
  const totals = new Array(playerCount).fill(0);
  if (sites.length === 0) return totals;

  const voronoi = buildVoronoi(sites, bounds);
  for (let i = 0; i < sites.length; i++) {
    totals[sites[i].player] += polygonArea(voronoi.cellPolygon(i));
  }
  return totals;
}
